export default __webpack_public_path__ + "static/media/D4W.8ab81810.png";